<template>
  <!-- 饼状图报表 -->
  <div class="pie-report-container">
    <div class="pie-report-map" ref="pieReport"></div>
    <div v-if="options.legendData && isDraw" :class="['hint', hintPosition && 'custom-page-hint']">
        <span class="item" v-for="item in getLegend(hintPosition ? 1 : 3)" :key="item.color" :title="item.name">
          <span class="item-color" :style="{background: item.color}"></span>
          <span class="name" :style="getFontStyle(chartFont, true)">{{ item.name }}</span>
        </span>
      <span v-if="options.legendData.length > (hintPosition ? 1 : 3)"
            :class="!isOpen ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" @click.stop="isOpen = !isOpen"
            :style="getFontStyle(chartFont, true)"></span>
      <transition name="el-zoom-in-top">
        <div v-show="isOpen" :class="['list-color', hintPosition && 'custom-list-color']" :style="{'background-color': getBgc(bgc)}">
          <span class="item" v-for="item in getLegend(options.legendData.length, hintPosition ? 1 : 3)"
                :key="item.color" :title="item.name">
            <span class="item-color" :style="{background: item.color}"></span>
            <span class="name" :style="getFontStyle(chartFont, true)">{{ item.name }}</span>
          </span>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { publicMethods } from './mixin'
import Vue from 'vue'
let echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/pie')
Vue.use(echarts)
export default {
  name: 'pie-report',
  props: ['graphData', 'norm', 'dimensionality', 'hintPosition', 'isMagnify'],
  data () {
    return {
      options: {},
      isOpen: false,
      isDraw: false,
      myChart: null,
      count: 0
    }
  },
  mixins: [ publicMethods ],
  methods: {
    drawLine () {
      if (this.myChart) {
        this.myChart.dispose()
      }
      this.isOpen = false
      let newData = this.$_.cloneDeep(this.graphData)
      newData.forEach(m => {
        m.dataDimension.forEach(o => {
          o.value = this.handleData(o.value, this)
        })
      })
      this.$set(this, 'options', this.$_.cloneDeep(this.disposeData(newData)))
      this.$nextTick(() => {
        let _self = this
        _self.isDraw = true
        // 基于准备好的dom，初始化echarts实例
        this.myChart = echarts.init(this.$refs.pieReport, undefined, this.getWH())
        // 指定图表的配置项和数据
        let data = this.options.series.map(a => ({value: a.data[0], name: a.name}))
        let option = {
          color: this.options.color,
          stillShowZeroSum: false,
          series: [
            {
              type: 'pie',
              label: {
                normal: {
                  show: true,
                  textStyle: this.getTextStyle,
                  formatter: (obj) => {
                    let value = obj.value
                    let oldValue = obj.value
                    let norm = _self.norm
                    if (norm && norm.showType === '显示千分位分隔符') {
                      value = _self.formatMoney(value)
                    } else if (norm && norm.showType === '显示百分比') {
                      value = value + '%'
                    }
                    if (norm && (norm.showUnit === '元' || norm.showUnit === '件')) {
                      value += norm.showUnit
                    } else if (norm && norm.showUnit === '万元') {
                      value = oldValue
                      if (norm.showType === '显示千分位分隔符') {
                        value = _self.formatMoney(value)
                      } else if (norm.showType === '显示百分比') {
                        value = value + '%'
                      }
                      value = value + '万元'
                    } else if (norm && norm.showUnit === '%' && norm && norm.showType !== '显示百分比') {
                      value = value + '%'
                    }
                    return `${_self.disposeYear(obj.name)}：${value}`
                  }
                }
              },
              data,
              labelLine: {
                normal: {
                  length: 5,
                  length2: 5
                }
              }
            }
          ],
          tooltip: {
            position: point => point
          }
        }
        // 使用刚指定的配置项和数据显示图表。
        this.myChart.setOption(option)
      })
    },
    handleData (value, _self) {
      let oldValue = value
      let norm = _self.norm
      let decimalDigits = _self.norm ? _self.norm.decimalDigits : ''
      let percent = (value / _self.count) * 100
      if (norm.showUnit !== '%' && decimalDigits !== '' && decimalDigits !== '请选择') {
        value = value.toFixed(parseFloat(norm.decimalDigits))
      }
      if (norm && norm.showType === '显示千分位分隔符') {
        value = _self.formatMoney(value)
      } else if (norm && norm.showType === '显示百分比') {
        if (decimalDigits !== '' && decimalDigits !== '请选择') {
          value = percent.toFixed(decimalDigits)
        }
      }
      if (norm && norm.showUnit === '万元') {
        value = oldValue / 10000
        if (decimalDigits !== '' && decimalDigits !== '请选择') {
          value = value.toFixed(parseFloat(norm.decimalDigits))
        }
        if (norm.showType === '显示千分位分隔符') {
          value = _self.formatMoney(value)
        } else if (norm.showType === '显示百分比') {
          if (decimalDigits !== '' && decimalDigits !== '请选择') {
            value = percent.toFixed(decimalDigits)
          } else {
            value = percent
          }
        }
      } else if (norm && norm.showUnit === '%' && norm && norm.showType !== '显示百分比') {
        if (decimalDigits !== '' && decimalDigits !== '请选择') {
          value = parseFloat(value * 100).toFixed(parseFloat(norm.decimalDigits))
        } else {
          value = parseFloat((value * 100).toFixed(10))
        }
      }
      return value
    },
    disposeData (list) {
      list = this.$_.cloneDeep(list)
      let color = this.getDefaultColors(list[0].dataDimension.length)
      let xAxisData = list.map(li => li.dateDimension)
      let legendData = []
      let series = []
      list && list.forEach((li, i) => {
        if (i === 0) {
          legendData = li.dataDimension.map(d => d.name)
        }
        li.dataDimension.forEach((d, x) => {
          if (series[x] === undefined) {
            series.push({
              name: d.name,
              type: 'bar',
              data: [d.value]
            })
          } else {
            series[x].data.push(d.value)
          }
        })
      })
      return {xAxisData, legendData, series, color}
    },
    resize () {
      this.setEchartsVisual('pieReport')
      this.myChart && this.myChart.resize(this.getWH())
    }
  },
  created () {
    this.count = this.getCount()
  },
  mounted () {
    this.$nextTick(() => {
      this.setEchartsVisual('pieReport')
    })
  }
}
</script>

<style lang="scss">
  .pie-report-container {
    width: 100%;
    height: 100%;
    position: relative;
    .hint {
      position: absolute;
      right: 15px;
      width: 280px;
      z-index: 999;
      height: 20px;
      top: 0;
      .item {
        margin-left: 38px;
        width: 50px;
        display: inline-block;
        position: relative;
        cursor: pointer;
        .item-color {
          position: absolute;
          left: -20px;
          top: 4px;
          width: 12px;
          height: 12px;
        }
        .name {
          width: 50px;
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .el-icon-arrow-down, .el-icon-arrow-up {
        position: absolute;
        right: -9px;
        top: 2px;
        cursor: pointer;
      }
      .list-color {
        position: absolute;
        right: 0px;
        top: 24px;
        height: 150px;
        width: 280px;
        overflow: auto;
        background-color: #fff;
        z-index: 999;
        box-shadow: 0 0 4px 3px #EBEBEB;;
        border-radius: 4px;
        padding: 5px 0;
      }
      .custom-list-color {
        top: -130px;
        width: 195px;
        padding-left: 4px;
        height: 125px;
      }
    }
    .custom-page-hint {
      bottom: 0;
      top: inherit;
      width: 90px;
      text-align: left;
      .item {
        .name {
          width: 40px;
        }
      }
    }
    .set-bottom {
      bottom: 15px;
      top: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/graphReport/pie-report.vue